import React, { useState, useRef, useCallback } from "react";
import ProgramCard from "./ProgramCard";
import MapView from "./MapView";
import NewGoogleMap from "./NewGoogleMap";

const ListeCarte = ({
  listeDesProgrammes,
  programmeListMap,
  programmesCoordinates,
  filterInput,
  ongletType,
  ongletId,
  query,
  ongletName,
}) => {
  const [selectedProgram, setSelectedProgram] = useState(null);
  const searchInputRef = useRef(null);
  const itineraryRef = useRef(null);
  // Handler for map marker clicks - receives documentId string and finds the full programme object
  const handleMapProgramSelect = useCallback(
    (programIdOrNull) => {
      if (!programIdOrNull) {
        setSelectedProgram(null);
        return;
      }
      // Find the full programme object from programmeListMap
      const programme = programmeListMap?.find(
        (p) => p.documentId === programIdOrNull,
      );
      setSelectedProgram(programme || null);
    },
    [programmeListMap],
  );
  return (
    <div className="d-flex flex-column">
      <div className="d-flex p-0 gap10 mt-10 position-relative">
        <div className="w40">
          <ProgramCard
            listeDesProgrammes={programmeListMap}
            selectedProgram={selectedProgram}
            setSelectedProgram={setSelectedProgram}
            itineraryRef={itineraryRef}
          />
        </div>
        <div className="w70 position-sticky top-0" style={{ height: "100vh" }}>
          {/* <MapView
            locations={programmesCoordinates}
            zoom={4.6}
            searchOnMap={true}
            filterInput={filterInput}
            ongletType={ongletType}
            ongletId={ongletId}
            query={query}
            ongletName={ongletName}
            setSelectedProgram={setSelectedProgram}
            selectedProgram={selectedProgram}
          /> */}
          <NewGoogleMap
            searchInputRef={searchInputRef}
            itineraryRef={itineraryRef}
            filterInput={filterInput}
            ongletType={ongletType}
            ongletId={ongletId}
            query={query}
            ongletName={ongletName}
            setSelectedProgramId={handleMapProgramSelect}
            selectedProgramId={selectedProgram?.documentId}
            programmesCoordinatesData={programmesCoordinates}
            programmesCoordinatesProps={
              programmeListMap?.map((el) => el.documentId) || []
            }
            matchingProgrammes={
              programmeListMap?.map((el) => el.documentId) || []
            }
          />
        </div>
      </div>
    </div>
  );
};

export default ListeCarte;
